import pathToRegexp from 'path-to-regexp';
import template from 'lodash/template';

import types from 'config/types/path';
import pathRegex, { globalParentPath } from 'config/pathRegex';

import addQueryParam from './addQueryParam';
import tagToLearnLanguage from './tagToLearnLanguage';

const inProductQueryStringParam = 'in_product';

const getSearch = (path) => ('string' === typeof path ? path.split('?')[1] : path?.search);
const getPathname = (path) => ('string' === typeof path ? path.split('?')[0] : path?.pathname);

export const isInProduct = (path) => Boolean(getSearch(path)?.includes(inProductQueryStringParam));

export const getInProductLocale = (path) => {
  const search = getSearch(path);
  const locale = (/locale=([a-z]{2}(_[a-zA-Z]{2})?)/.exec(search) || [])[1];
  return locale;
};

const getLearnLanguageFromTags = (path) => {
  const pathname = getPathname(path);
  const tagsPathRegexp = template(pathRegex[types.TERM_ARCHIVE])({ contentTypes: '[\\w-]+' });
  const fullTagsPathRegexp = `${pathRegex[globalParentPath]}${tagsPathRegexp}`;
  const pathParams = [];
  const tagsPathMatch = pathToRegexp(fullTagsPathRegexp, pathParams).exec(pathname);
  const tag = (tagsPathMatch || [])[pathParams.findIndex(({ name }) => 'slug' === name) + 1];
  const locale = (tagsPathMatch || [])[pathParams.findIndex(({ name }) => 'language' === name) + 1];
  return (tag && locale) ? tagToLearnLanguage(locale, tag) : undefined;
};

const getLearnLanguageFromSearch = (path) => {
  const search = getSearch(path);
  const learnLanguageSearchRegexp = /learn_language=([A-Z]{3}(_[a-zA-Z]{2})?)/;
  return (learnLanguageSearchRegexp.exec(search) || [])[1];
};

export const getInProductLearnLanguage = (path) =>
  getLearnLanguageFromSearch(path) || getLearnLanguageFromTags(path);

export const makePathInProduct = (path, locale, learnLanguage) => {
  let pathInProduct = addQueryParam(path, inProductQueryStringParam);
  if (locale) {
    pathInProduct = addQueryParam(pathInProduct, `locale=${locale}`);
  }
  if (learnLanguage) {
    pathInProduct = addQueryParam(pathInProduct, `learn_language=${learnLanguage}`);
  }
  return pathInProduct;
};
